import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["onChange", "onFocus"];
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/**
 * @jsxRuntime classic
 * @jsx jsx
 */

// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { jsx } from '@emotion/react';
import debounce from 'debounce-promise';
import { useIntl } from 'react-intl-next';
import { Field } from '@atlaskit/form';
import { AsyncSelect } from '@atlaskit/select';
import { layers } from '@atlaskit/theme/constants';
import { useObjectSchemas } from '../../../../hooks/useObjectSchemas';
import { objectSchemaKey } from '../../../../types/assets/types';
import { FieldContainer } from '../styled';
import { objectSchemaSelectMessages } from './messages';
import { objectSchemaToSelectOption } from './utils';
export var SEARCH_DEBOUNCE_MS = 350;
var mapObjectSchemasToOptions = function mapObjectSchemasToOptions(objectSchemas) {
  return objectSchemas ? objectSchemas.map(function (objectSchema) {
    return objectSchemaToSelectOption(objectSchema);
  }) : [];
};

/**
 * Rendering a `<Select>` in a `<Modal>` results in the select options getting cut off by the bottom of the modal and
 * scrolling. This is a work-around for that, see https://atlassian.slack.com/archives/CFJ9DU39U/p1623179496484100
 */
export var selectInAModalStyleFixProps = {
  styles: {
    menuPortal: function menuPortal(base) {
      return _objectSpread(_objectSpread({}, base), {}, {
        zIndex: layers.modal()
      });
    }
  },
  menuPortalTarget: document.body
};
export var AssetsObjectSchemaSelect = function AssetsObjectSchemaSelect(_ref) {
  var value = _ref.value,
    workspaceId = _ref.workspaceId,
    initialObjectSchemas = _ref.initialObjectSchemas,
    _ref$classNamePrefix = _ref.classNamePrefix,
    classNamePrefix = _ref$classNamePrefix === void 0 ? 'assets-datasource-modal--object-schema-select' : _ref$classNamePrefix;
  var _useIntl = useIntl(),
    formatMessage = _useIntl.formatMessage;
  var _useObjectSchemas = useObjectSchemas(workspaceId),
    fetchObjectSchemas = _useObjectSchemas.fetchObjectSchemas,
    objectSchemasLoading = _useObjectSchemas.objectSchemasLoading;
  var selectedObjectSchema = value ? objectSchemaToSelectOption(value) : undefined;
  var loadOptions = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(inputValue) {
      var _yield$fetchObjectSch, objectSchemas;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return fetchObjectSchemas(inputValue);
          case 2:
            _yield$fetchObjectSch = _context.sent;
            objectSchemas = _yield$fetchObjectSch.objectSchemas;
            return _context.abrupt("return", mapObjectSchemasToOptions(objectSchemas));
          case 5:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function loadOptions(_x) {
      return _ref2.apply(this, arguments);
    };
  }();
  var debouncedLoadOptions = debounce(loadOptions, SEARCH_DEBOUNCE_MS);
  var validateSchema = function validateSchema(value) {
    if (!value || !value.value) {
      return formatMessage(objectSchemaSelectMessages.schemaRequired);
    }
    return undefined;
  };
  return jsx(FieldContainer, null, jsx(Field, {
    name: objectSchemaKey,
    defaultValue: selectedObjectSchema,
    validate: function validate(value) {
      return validateSchema(value);
    }
  }, function (_ref3) {
    var _ref3$fieldProps = _ref3.fieldProps,
      _onChange = _ref3$fieldProps.onChange,
      onFocus = _ref3$fieldProps.onFocus,
      restFieldProps = _objectWithoutProperties(_ref3$fieldProps, _excluded);
    return jsx(AsyncSelect, _extends({
      autoFocus: true,
      classNamePrefix: classNamePrefix,
      isLoading: objectSchemasLoading,
      defaultOptions: mapObjectSchemasToOptions(initialObjectSchemas),
      isSearchable: true,
      loadOptions: debouncedLoadOptions,
      placeholder: formatMessage(objectSchemaSelectMessages.placeholder),
      onChange: function onChange(newOption) {
        return newOption && _onChange(newOption);
      }
    }, selectInAModalStyleFixProps, restFieldProps));
  }));
};